import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';

// 10 minutes frontend cache for page layout query
const CACHE_TIME = 10 * 60 * 1000;

export const useCmsPageLayoutQuery = (slug: string | undefined) => {
  return useQuery({
    queryKey: ['cms-page', { slug: slug! }],
    queryFn: fetchCmsPageLayout,
    enabled: !!slug,
    staleTime: CACHE_TIME,
  });
};

const fetchCmsPageLayout: QueryFunction<any, [string, { slug: string }]> = async ({ queryKey }) => {
  const [, { slug }] = queryKey;
  const { data } = await axios.get<any>(API.endpoints.pageLayout, {
    params: {
      slug,
    },
  });
  return data;
};
